module.exports = __webpack_public_path__ + "static/img/v74Bg-p.ce39843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v74Bg-p.png
// module id = NRBt
// module chunks = 1